module.exports = __webpack_public_path__ + "static/media/SPADE-10.7e4ea0e6.svg";